document.addEventListener('DOMContentLoaded', function () {

  const triggers = document.querySelectorAll('[data-accordion-trigger]');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {

      const triggerValue = trigger.getAttribute('data-accordion-trigger');

      const contentElement = document.querySelector(`[data-accordion-collapsible="${triggerValue}"]`);
      const triggerIconElement = document.querySelector(`[data-accordion-trigger-icon="${triggerValue}"]`);
      const iconElement = triggerIconElement.querySelector('i');

      if (contentElement) {
        contentElement.classList.toggle('d-none');
        contentElement.classList.toggle('d-block');
        iconElement.classList.toggle('im-plus');
        iconElement.classList.toggle('im-minus');
      }
    });
  });
});
